import { NextPage } from 'next'
import Head from 'next/head'
import PageHeader from '@components/PageHeader'
import Link from '@components/Link'
import { Layout, ImagesGrid, TextBlock, Blocks } from '@components/work'
import Button from '@components/Button'

const LabelMagazinePage: NextPage = () => (
  <>
    <Head>
      <title>Work - Label Magazine</title>
    </Head>

    <PageHeader
      title={[['Label Magazine']]}
      subtitle={[
        [
          'outstanding publication',
          'for people',
          'who are',
          'passionate',
          'about design, art, photography',
          'and architecture.',
        ],
      ]}
    />

    <Layout>
      <ImagesGrid
        images={[
          { src: '/images/work/label-magazine/01.jpg', alt: '' },
          { src: '/images/work/label-magazine/02.jpg', alt: '' },
        ]}
      />

      <Blocks>
        <TextBlock>
          <p>
            We prepared a custom solution for a creative magazine. This project
            is unique in many respects - beautiful animations, unique features,
            e-commerce. All this is managed from the level of an easy panel.
          </p>
        </TextBlock>

        <TextBlock title="You will find here:">
          <ol>
            <li>
              a tool that allows you to create your own mood boards from all
              available photos in articles. Use our publications, search for,
              and save inspiration. It is not enough? Tag your favorite articles
              so you don't forget about them.
            </li>
            <li>
              custom page builder for articles. Built from 0 for the needs of
              this project to be 100% compatible with great design and to be as
              easy to use as possible. There is also no problem to submit your
              own article for publication as a user. Become an author!
            </li>
            <li>
              A shop that allows you to order physical products, subscriptions
              to all Label magazines, and online issues that you can view on the
              site.
            </li>
            <li>
              The built-in notification system will send you information about
              the new issue, important and interesting articles.
            </li>
          </ol>

          <p>
            Design & UX - Damian Skotzke -{' '}
            <Link
              target="_blank"
              rel="noreferrer noopener"
              href="https://tzke.pl/"
            >
              tzke.pl
            </Link>
          </p>

          <a
            target="_blank"
            rel="noreferrer noopener"
            href="https://label-magazine.com/"
            className="d-inline-block"
          >
            <Button theme="red-outline" text="Check it out" />
          </a>
        </TextBlock>
      </Blocks>

      <ImagesGrid
        images={[
          { src: '/images/work/label-magazine/03.jpg', alt: '' },
          { src: '/images/work/label-magazine/04.jpg', alt: '' },
        ]}
      />
    </Layout>
  </>
)

export default LabelMagazinePage
